import React, { Component } from 'react';
import { connect } from 'react-redux';
import './projectcategories.css';
import Button from '../button/button';

import { updateProjectFilter } from '../../actions/projectsActions';

import get from 'lodash.get';
import has from 'lodash.has';

class Projectcategories extends Component {

    constructor(props) {
        super(props);

        this.setFilter = this.setFilter.bind(this);
        this.setFilterByProjectId = this.setFilterByProjectId.bind(this);
    }

    setFilter(projectCategory) {

        this.props.dispatch(updateProjectFilter(projectCategory));
    }

    setFilterByProjectId(event) {
        let projectId = event.target.value;

        if (has(this, 'props.projectcategories')) {
            const projectcategories = get(this, 'props.projectcategories');

            let project = projectcategories.filter((projectcategory) => {
                return Number(projectId) === projectcategory.id;
            });

            if (project.length) {
                this.setFilter(project.shift());
            } else {
                this.setFilter();
            }
        }

    }

    render() {

        return (
            <div>
                <ul className="projectcategories">
                    {
                        this.props.projectcategories.map((projectcategory, index) => {
                            let selected = (get(this.props, 'filter.id') === projectcategory.id);
                            return ( <li key={projectcategory.id} onClick={() => this.setFilter(projectcategory)}><Button color="yellow" name={projectcategory.name} active={selected}/></li> )
                        })
                    }
                </ul>

                <div className="projectcategories--dropdown">
                    <select onChange={this.setFilterByProjectId} value={get(this.props, 'filter.id')}>
                        <option key="all" value="all">Alle projecten</option>
                        {
                            this.props.projectcategories.map((projectcategory, index) => {
                            return ( <option key={projectcategory.id} value={projectcategory.id} dangerouslySetInnerHTML={{__html:projectcategory.name}}/> )
                        })
                    }
                    </select>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const projectcategories = get(state, 'projectcategories.projectcategories', []);
    const filter = get(state, 'projects.filter');

    return {
        projectcategories: projectcategories,
        filter: filter
    }
}

export default connect(mapStateToProps)(Projectcategories);



// WEBPACK FOOTER //
// ./src/components/projectcategories/projectcategories.js